export const preOpBoardColumns = [
  { id: 'surgeon', label: 'Surgeon', minWidth: 95 },
  { id: 'caseOrder', label: 'Case Order', minWidth: 95 },
  { id: 'time', label: 'Time', minWidth: 70 },
  { id: 'name', label: 'Name', minWidth: 115 },
  { id: 'bay', label: 'Bay', minWidth: 50 },
  { id: 'nurse', label: 'Pre-OP RN', minWidth: 85 },
  { id: 'mda', label: 'MDA', minWidth: 100 },
  { id: 'anesthesia', label: 'Anes Type', minWidth: 75 },
  { id: 'anesthesiaReady', label: 'A-Ready', minWidth: 60 },
  { id: 'surgeonReady', label: 'S-Ready', minWidth: 60 },
  { id: 'historyAndPhysical', label: 'H&P', minWidth: 60 },
  { id: 'event', label: 'Event', minWidth: 105 },
] as const;

export type PreOpBoardColumnId = (typeof preOpBoardColumns)[number]['id'];

const storageKey = 'preOpBoardHiddenColumns';

export const readHiddenPreOpBoardColumns = (): PreOpBoardColumnId[] => {
  try {
    const saved: unknown = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!Array.isArray(saved)) return [];
    return preOpBoardColumns
      .filter(column => column.id !== 'name' && saved.includes(column.id))
      .map(column => column.id);
  } catch {
    return [];
  }
};

export const saveHiddenPreOpBoardColumns = (columns: PreOpBoardColumnId[]) => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(columns.filter(id => id !== 'name')));
  } catch {
    // The board remains usable when browser storage is unavailable.
  }
};

export const resetPreOpBoardColumns = () => {
  try {
    localStorage.removeItem(storageKey);
  } catch {
    // Pairing must still succeed when browser storage is unavailable.
  }
};
